// test2092
(2092 && 0);
